import referenceSearchInstance from "./axios-instance";
import type {
  ReferenceTableId,
  ReferenceTableResponse,
  ReferenceXbrlMappingResponse,
  SearchReferenceTablesRequest,
  SearchReferenceTablesResponse,
} from "./types";

export const postSearchReferenceTables = async (
  payload: SearchReferenceTablesRequest,
): Promise<SearchReferenceTablesResponse> => {
  const response = await referenceSearchInstance.post<SearchReferenceTablesResponse>(
    "/v1/reference-search/search",
    payload,
  );
  return response.data;
};

export const getReferenceTable = async (
  id: ReferenceTableId,
): Promise<ReferenceTableResponse> => {
  const response = await referenceSearchInstance.get<ReferenceTableResponse>(
    `/v1/reference-search/tables/${id.rceptNo}/${id.attachmentCode}/${id.noteId}/${id.subIndex}`,
  );
  return response.data;
};

export const getReferenceTableXbrlMapping = async (
  id: ReferenceTableId,
): Promise<ReferenceXbrlMappingResponse> => {
  const response = await referenceSearchInstance.get<ReferenceXbrlMappingResponse>(
    `/v1/reference-search/tables/${id.rceptNo}/${id.attachmentCode}/${id.noteId}/${id.subIndex}/xbrl-mapping`,
  );
  return response.data;
};
